import React from 'react';
import Header from '../components/Header';

function NotFound() {
  return (
    <>
      <Header />
      <h1>404 - Página não encontrada</h1>
      <div>Desculpe, a página que você está procurando não existe.</div>
    </>
  );
}

export default NotFound;
